export default __webpack_public_path__ + "645e1f3d9c0d3b0e0dd103dbae0d6467.svg";